import React, { useEffect, useState } from "react";
import PartnerAffiliateCard from "./PartnerAffiliateCard";

const headers = () => {
  const t = localStorage.getItem("access_token") || localStorage.getItem("token") || "";
  return { "Content-Type": "application/json", Authorization: "Bearer " + t };
};

const OPTIONS = [
  { value: "open", title: "Open", desc: "Anyone can register as an investor, trader or analyst on your domain." },
  { value: "appointed", title: "Appointed only", desc: "Anyone can register as an investor. Trader and analyst accounts are appointed by you from the Members tab." },
];

const PartnerSignupTab = () => {
  const [mode, setMode] = useState(null);
  const [type, setType] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () =>
    fetch("/api/partner-admin/signup-policy", { headers: headers() })
      .then((r) => r.json())
      .then((d) => {
        if (d.ok && d.data) {
          setMode(d.data.providerMode);
          setType(d.data.partnerType || "");
        }
      })
      .catch(() => {});

  useEffect(() => { load(); }, []);

  const save = (value) => {
    if (value === mode) return;
    setBusy(true);
    fetch("/api/partner-admin/signup-policy", { method: "PUT", headers: headers(), body: JSON.stringify({ providerMode: value }) })
      .then((r) => r.json())
      .then((d) => {
        setMsg(d.message || d.error || "Saved");
        setTimeout(() => setMsg(""), 4000);
        return load();
      })
      .finally(() => setBusy(false));
  };

  return (
    <div style={{ maxWidth: 760 }}>
      <h3 style={{ color: "var(--text-main)", marginTop: 0 }}>Registration</h3>
      <p style={{ color: "var(--text-muted)", fontSize: 14, lineHeight: 1.5 }}>
        Choose who can register as a provider (trader or analyst) in your community. Community type: <strong>{type || "-"}</strong>.
        Existing accounts are not affected. The change applies immediately to the sign-up page.
      </p>
      {msg && <div style={{ background: "var(--success)", color: "#fff", padding: "8px 16px", borderRadius: 6, marginBottom: 16, display: "inline-block" }}>{msg}</div>}
      {mode === null ? (
        <div style={{ color: "var(--text-muted)" }}>Loading...</div>
      ) : (
        OPTIONS.map((o) => (
          <div key={o.value} onClick={() => !busy && save(o.value)}
            style={{ cursor: busy ? "default" : "pointer", marginBottom: 12, padding: 16, borderRadius: 8,
              border: "1px solid " + (mode === o.value ? "var(--accent)" : "var(--border)"),
              background: "var(--bg-surface)" }}>
            <div style={{ color: "var(--text-main)", fontWeight: 700 }}>{o.title}{mode === o.value ? "  (current)" : ""}</div>
            <div style={{ color: "var(--text-muted)", fontSize: 13, marginTop: 4 }}>{o.desc}</div>
          </div>
        ))
      )}
      <PartnerAffiliateCard />
    </div>
  );
};

export default PartnerSignupTab;
